<template>
  <div class="checkout-builder-timer-modal">
    <snow-input
      v-model.number="hours"
      number
      id="hours"
      label="Horas"
      :min="0"
    />
    <snow-input
      v-model.number="minutes"
      number
      id="minutes"
      label="Minutos"
      :min="0"
      :max="59"
    />
    <snow-input
      v-model.number="seconds"
      number
      id="seconds"
      label="Segundos"
      :min="0"
      :max="59"
    />

    <!-- <bp-input
      v-model="form.countdownText"
      class="mb-5"
      id="countdownText"
      label="Texto do contador"
      placeholder="Ex.: Essa oferta irá expirar..."
    />

    <form-group
      v-model="form.countdownTextColor"
      color
      label="Cor do texto"
      id="text-color"
      placeholder="Ex.: #000000"
    />

    <form-group
      v-model="form.countdownBackgroundColor"
      color
      class="mb-5"
      label="Cor de fundo"
      id="background-color"
      placeholder="Ex.: #FFFFFF"
    /> -->

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        text="Cancelar"
        variant="gray"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        text="Inserir Cronômetro"
        @click="save"
        :disabled="!isValid"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(
        [
          "countdownTime"
          // "countdownText",
          // "countdownTextColor",
          // "countdownBackgroundColor"
        ],
        {
          countdownTime: this.data.countdownTime ?? 0
          // countdownText:
          //   this.data.countdownText ?? "Essa oferta irá expirar...",
          // countdownTextColor: this.data.countdownTextColor ?? "#FFFFFF",
          // countdownBackgroundColor:
          //   this.data.countdownBackgroundColor ?? "#ee6469"
        }
      ),
      hours: Math.floor((this.data.countdownTime ?? 0) / 3600),
      minutes: Math.floor(((this.data.countdownTime ?? 0) % 3600) / 60),
      seconds: (this.data.countdownTime ?? 0) % 60
    };
  },
  computed: {
    isValid() {
      return this.hours + this.minutes + this.seconds > 0;
    }
  },
  methods: {
    save() {
      this.form.countdownTime =
        this.hours * 3600 + this.minutes * 60 + this.seconds;
      this.$emit("save", {
        type: "timer",
        ...this.form
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.checkout-builder-timer-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
